<template>
    <div class="main-box mh-a">
        <iristar-dividing> {{ $t("HOME_NAV.news") }} </iristar-dividing>
        <el-row :gutter="10" class="iristar-pro-item p20 c-pointer p-r" v-for="(item, index) in newsList"
            :key="`${index}_product`" @click.native="jumpDetail(item)">
            <el-col :xs="24" :sm="8">
                <el-image class="m-news" :src="item.img" fit="cover"></el-image>
            </el-col>
            <el-col :xs="24" :sm="12" class="m-news-info">
                <h4 class="fs24 fw-b">{{ item.title }}</h4>
                <!-- <p class="text-right lh30 fs14 c-g-d">{{ item.time }}</p> -->
                <p class="fs14 text-indent lh30 c-g-d pc-hidden">
                    {{ item.desc }}
                </p>
            </el-col>
            <el-link type="primary" class="p-a plink p10 pc-hidden">查看全文></el-link>
        </el-row>
    </div>
</template>

<script>
import IristarDividing from "@/components/IristarDividing";
import NewsList from "@/assets/news/newsList";
import NewsListEn from "@/assets/news/newsList-en";
export default {
    name: "IristarNews",
    computed: {
        newsList() {
            return this.$store.state.language === "zh" ? NewsList : NewsListEn;
        },
    },
    methods: {
        jumpDetail(obj) {
            this.$router.push({ path: `/news-details/${obj.id}` });
        },
    },
    components: {
        IristarDividing,
    },
};
</script>

<style></style>